export default "__VITE_ASSET__Cd4aU7dD__"